<template>
  <div>
    <div style="display: flex" class="mb-3">
      <div v-for="status in statusOptions" :key="status.value" class="mx-2">
        <em
          class="fas fa-circle"
          :style="{
            color: status.color
          }"
        ></em>
        <span class="black--text ml-1" style="font-size: 14px">
          {{ status.label }}
        </span>
      </div>
    </div>

    <v-card>
      <v-card-text>
        <v-layout row wrap class="mb-2">
          <v-flex xs12 sm6>
            <v-menu
              v-model="monthPickerModal"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template #activator="{ on }">
                <v-text-field
                  :value="displayMonth"
                  :label="$t('select_month')"
                  prepend-icon="event"
                  readonly
                  style="max-width: 300px"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="currentMonth"
                type="month"
                color="primary"
                @input="monthPickerModal = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 style="display: flex; justify-content: flex-end">
            <v-select
              v-model="type"
              :items="typeOptions"
              :label="$t('follow_up.view_type')"
              style="max-width: 300px"
            >
            </v-select>
          </v-flex>
          <v-flex xs12>
            <v-toolbar dense class="elevation-0">
              <v-btn flat small @click="$refs.calendar.prev()">
                <v-icon dark left> keyboard_arrow_left </v-icon>
                {{ $t('previous') }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-toolbar-title>{{ displayMonth }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn flat small @click="$refs.calendar.next()">
                {{ $t('next') }}
                <v-icon right dark> keyboard_arrow_right </v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>
        </v-layout>

        <template v-if="currentMonth">
          <div class="follow-up-calendar">
            <v-sheet style="overflow: auto">
              <v-calendar
                ref="calendar"
                v-model="start_date"
                :type="type"
                :start="start_date"
                :end="end_date"
                :now="today"
                :color="'primary'"
                @click:date="handleSelectDay($event)"
              >
                <template #day="{ date }">
                  <v-sheet>
                    <FollowUpTaskList
                      :value="followUpTasks[date]"
                      :hide-action="true"
                      @onViewMore="handleSelectDay({ date: date })"
                    />
                  </v-sheet>
                </template>
                <template #dayHeader="{ date }">
                  <v-sheet style="min-height: 200px">
                    <FollowUpTaskList
                      :value="followUpTasks[date]"
                      :hide-action="false"
                      @onViewMore="handleSelectDay({ date: date })"
                    />
                  </v-sheet>
                </template>
              </v-calendar>
            </v-sheet>
          </div>
        </template>
      </v-card-text>
    </v-card>

    <template v-if="selectedDateItem">
      <FollowUpViewTaskDialog
        :dialog-open="dialogOpen"
        :item="selectedDateItem"
        :selected-date="selectedDate"
        @onClose="
          () => {
            dialogOpen = false
            selectedDateItem = null
          }
        "
      />
    </template>
  </div>
</template>

<script>
import kmbApi from '@/api/kmb'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import FollowUpViewTaskDialog from './FollowUpViewTaskDialog.vue'
import FollowUpTaskList from './FollowUpTaskList.vue'

export default {
  components: {
    FollowUpViewTaskDialog,
    FollowUpTaskList
  },

  data() {
    return {
      type: 'month',
      start_date: dayjs().format('YYYY-MM-01'),
      end_date: dayjs().endOf('month').format('YYYY-MM-DD'),
      typeOptions: [
        { text: this.$t('view_type_week'), value: 'week' },
        { text: this.$t('view_type_month'), value: 'month' }
      ],
      followUpTasks: [],
      today: dayjs().format('YYYY-MM-DD'),

      currentMonth: null,
      menu: false,
      monthPickerModal: false,
      dialogOpen: false,
      selectedDate: null,
      selectedDateItem: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    displayMonth() {
      return this.start_date ? dayjs(this.start_date).format('MMMM YYYY') : ''
    },
    statusOptions() {
      return [
        { label: this.$t('follow_up.status.pending'), value: 'pending', color: '#ffecb3' },
        { label: this.$t('follow_up.status.in_progress'), value: 'in_progress', color: '#F0B582' },
        { label: this.$t('follow_up.status.complete'), value: 'complete', color: '#c1e1c1' },
        { label: this.$t('follow_up.status.cancel'), value: 'cancel', color: '#ffd4d3' }
      ]
    }
  },
  watch: {
    start_date: {
      handler() {
        this.currentMonth = dayjs(this.start_date).format('YYYY-MM')
      }
    },
    currentMonth: {
      handler() {
        this.start_date = dayjs(this.currentMonth).format('YYYY-MM-01')
        this.end_date = dayjs(this.currentMonth).endOf('month').format('YYYY-MM-DD')

        this.handleFetchKmbFollowUpTask()
      },
      deep: true
    },
    type: {
      handler() {
        if (this.type === 'week') {
          this.start_date = dayjs().format('YYYY-MM-DD')
        } else {
          this.currentMonth = dayjs().format('YYYY-MM')
          this.start_date = dayjs().format('YYYY-MM-01')
          this.end_date = dayjs().endOf('month').format('YYYY-MM-DD')
        }
      }
    }
  },
  mounted() {
    this.handleInitial()
  },
  methods: {
    handleInitial() {
      this.currentMonth = dayjs().format('YYYY-MM')
      this.start_date = dayjs().format('YYYY-MM-01')
      this.end_date = dayjs().endOf('month').format('YYYY-MM-DD')
    },
    async handleFetchKmbFollowUpTask() {
      const vm = this

      try {
        if (!vm.selectedBot.pageid) return

        const tempStartDate = dayjs(vm.currentMonth).format('YYYY-MM-01')
        const tempEndDate = dayjs(vm.currentMonth).endOf('month').format('YYYY-MM-DD')

        const params = {
          page_id: vm.selectedBot.pageid,
          start_date: dayjs(tempStartDate).subtract(7, 'days').format('YYYY-MM-DD'),
          end_date: dayjs(tempEndDate).add(7, 'day').format('YYYY-MM-DD')
        }

        const response = await kmbApi.getFollowUpTask({
          params
        })

        if (response && response.status === 200) {
          const responseData = response.data.data || []

          const mapTasks = responseData.map((task) => {
            return {
              id: task.id,
              app: task.app,
              first_name: task.first_name,
              last_name: task.last_name,
              title: task.subject,
              details: task.description,
              date: dayjs(task.start_date).format('YYYY-MM-DD'),
              status: task.status,
              sub_status: task.sub_status,
              user_id: task.user_id,
              start_date: dayjs(task.start_date).format('YYYY-MM-DD'),
              end_date: dayjs(task.end_date).format('YYYY-MM-DD'),
              start_time: task.start_time
                ? dayjs(`${dayjs(task.start_date).format('YYYY-MM-DD')} ${task.start_time}`).format(
                    'YYYY-MM-DD HH:mm'
                  )
                : '',
              end_time: task.end_time
                ? dayjs(`${dayjs(task.start_date).format('YYYY-MM-DD')} ${task.end_time}`).format(
                    'YYYY-MM-DD HH:mm'
                  )
                : ''
            }
          })

          const sortTasks = mapTasks.sort((a, b) => a.start_time.localeCompare(b.start_time))

          const reduceTasks = sortTasks.reduce(
            (prev, cur) => ({
              ...prev,
              [cur.start_date]: (prev[cur.start_date] || []).concat(cur)
            }),
            {}
          )

          vm.followUpTasks = reduceTasks
        }
      } catch (error) {
        console.error(error)
      }
    },

    handleSelectDay(payload) {
      try {
        const tempItem = this.followUpTasks[payload.date] || []

        this.selectedDate = payload.date
        this.selectedDateItem = tempItem
        this.dialogOpen = true
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss">
.follow-up-calendar {
  .v-calendar-daily {
    min-width: 2000px !important;
  }
  .v-calendar-daily__body {
    display: none !important;
  }
  .v-calendar-daily__intervals-head {
    display: none !important;
  }
  .v-calendar-weekly__day {
    min-height: 84px;
  }
  .bg-pending {
    background-color: #ffecb3;
  }
  .bg-in_progress {
    background-color: #f0b582;
  }
  .bg-complete {
    background-color: #c1e1c1;
  }
  .bg-cancel {
    background-color: #ffd4d3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/Kmb/FollowUp/FollowUpCalendar.vue